import React, { createContext, useState, useContext } from 'react';
import { useTranslations } from 'next-intl';

const WebsiteContext = createContext<any>({
    selectedWebsite: 0,
    handleSelectedWebsite: (website: any) => {},
    websites: []
});

export const WebsiteProvider = ({ children }: { children: React.ReactNode }) => {
    const t = useTranslations('pages.request_website');

    const [selectedWebsite, setSelectedWebsite] = useState(0);

    const handleSelectedWebsite = (website: any) => {
        setSelectedWebsite(website);
    };

    const websites = [
        {
            id: 0,
            name: t('packages.items.0.name'),
            // price: t('packages.items.0.price'),
        },
        {
            id: 1,
            name: t('packages.items.1.name'),
            // price: t('packages.items.1.price'),
        },
        {
            id: 2,
            name: t('packages.items.2.name'),
            // price: t('packages.items.2.price'),
        },
        {
            id: 3,
            name: t('packages.items.3.name'),
            // price: t('packages.items.3.price'),
        }
    ];

    return (
        <WebsiteContext.Provider value={{ selectedWebsite, handleSelectedWebsite, websites }}>
            {children}
        </WebsiteContext.Provider>
    );
};

export const useWebsite = () => {
    return useContext(WebsiteContext);
};
